import React, { useEffect, useRef } from 'react';

function WrongAnswerItem({ item, idx }) {
  const userOpt = item.is_avoidance && item.special_option_label
    ? `选"${item.special_option_label}"`
    : (item.user_option ? `选 ${item.user_option}` : '未作答');
  return (
    <li
      key={item.question_id ?? idx}
      data-testid={`wrong-answer-item-${idx}`}
      data-avoidance={item.is_avoidance ? 'true' : 'false'}
      style={{
        padding: '14px 0', borderTop: idx === 0 ? 0 : '1px solid var(--color-border, #e2e8f0)',
        listStyle: 'none',
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6, gap: 8, flexWrap: 'wrap' }}>
        <span style={{ fontSize: 12, color: 'var(--color-text-muted)', fontWeight: 600 }}>
          Q{item.q_no}
        </span>
        {item.knowledge_point && (
          <span style={{ fontSize: 11, color: '#7c3aed', background: '#f3e8ff', padding: '1px 8px', borderRadius: 10, wordBreak: 'break-word', maxWidth: '100%' }}>
            {item.knowledge_point}
          </span>
        )}
      </div>
      {item.stem && (
        <p style={{ fontSize: 13, lineHeight: 1.6, margin: '0 0 8px', color: 'var(--color-text)', wordBreak: 'break-word' }}>
          {item.stem}
        </p>
      )}
      {Array.isArray(item.options) && item.options.length > 0 && (
        <ul style={{ margin: '0 0 8px', padding: 0, listStyle: 'none', display: 'flex', flexDirection: 'column', gap: 2 }}>
          {item.options.map(opt => (
            <li key={opt.key} style={{ fontSize: 12, color: 'var(--color-text-secondary)', lineHeight: 1.6, wordBreak: 'break-word' }}>
              <strong>{opt.key}.</strong> {opt.text}
            </li>
          ))}
        </ul>
      )}
      <div style={{ display: 'flex', gap: 14, fontSize: 12, marginTop: 4, flexWrap: 'wrap' }}>
        <span style={{ color: '#b91c1c' }}>{userOpt}</span>
        <span style={{ color: '#16a34a' }}>正确：{item.correct_option || '—'}</span>
      </div>
      {item.explanation && (
        <p style={{ fontSize: 12, color: 'var(--color-text-muted)', lineHeight: 1.7, margin: '8px 0 0', padding: 8, background: 'var(--color-bg-soft, #f8fafc)', borderRadius: 4, wordBreak: 'break-word' }}>
          解析：{item.explanation}
        </p>
      )}
    </li>
  );
}

export default function WrongAnswersDrawer({
  open, onClose, items = [], dimName = '',
  loading = false, error = null,
}) {
  const closeBtnRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => { if (e.key === 'Escape') onClose && onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  useEffect(() => {
    if (open && closeBtnRef.current) closeBtnRef.current.focus();
  }, [open]);

  if (!open) return null;
  return (
    <>
      <div
        onClick={onClose}
        data-testid="wrong-answers-drawer-backdrop"
        style={{ position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.4)', zIndex: 49 }}
      />
      <aside
        role="dialog"
        aria-modal="true"
        aria-label={`错题：${dimName}`}
        data-testid="wrong-answers-drawer"
        style={{
          position: 'fixed', top: 0, right: 0, bottom: 0,
          width: 420, maxWidth: '92vw',
          background: '#fff', boxShadow: '-4px 0 16px rgba(0,0,0,0.12)',
          zIndex: 50, display: 'flex', flexDirection: 'column',
        }}
      >
        <header style={{
          padding: '12px 16px 12px 20px', borderBottom: '1px solid var(--color-border, #e2e8f0)',
          display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8,
        }}>
          <h3 style={{ margin: 0, fontSize: 15, fontWeight: 700, minWidth: 0, wordBreak: 'break-word' }}>
            错题{dimName ? ` · ${dimName}` : ''}
            {!loading && !error && (
              <span style={{ marginLeft: 8, fontSize: 12, color: 'var(--color-text-muted)', fontWeight: 400 }}>
                共 {items.length} 题
              </span>
            )}
          </h3>
          <button
            ref={closeBtnRef}
            type="button"
            onClick={onClose}
            aria-label="关闭"
            style={{
              border: 0, background: 'transparent', fontSize: 24, cursor: 'pointer',
              color: 'var(--color-text-muted, #64748b)', lineHeight: 1,
              minWidth: 44, minHeight: 44, padding: 8, flexShrink: 0,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}
          >
            ×
          </button>
        </header>
        <div style={{ flex: 1, overflowY: 'auto', padding: '0 20px' }}>
          {loading && (
            <p style={{ padding: '40px 0', textAlign: 'center', color: 'var(--color-text-muted)' }}>
              加载错题中...
            </p>
          )}
          {!loading && error && (
            <p style={{ padding: '40px 0', textAlign: 'center', color: '#b91c1c' }}>
              加载错题失败，请稍后重试
            </p>
          )}
          {!loading && !error && items.length === 0 && (
            <p style={{ padding: '40px 0', textAlign: 'center', color: 'var(--color-text-muted)' }}>
              该维度暂无错题
            </p>
          )}
          {!loading && !error && items.length > 0 && (
            <ul style={{ margin: 0, padding: 0 }}>
              {items.map((item, idx) => (
                <WrongAnswerItem key={item.question_id ?? idx} item={item} idx={idx} />
              ))}
            </ul>
          )}
        </div>
      </aside>
    </>
  );
}
